/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UiSandboxRouteImport } from './routes/ui-sandbox'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as EmbedRouteImport } from './routes/embed'
import { Route as AgentRouteImport } from './routes/agent'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AuthWaitlistRouteImport } from './routes/_auth/waitlist'
import { Route as AuthVerifySignInRouteImport } from './routes/_auth/verify-sign-in'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthTwoFactorRouteImport } from './routes/_auth/two-factor'
import { Route as AuthSsoCallbackRouteImport } from './routes/_auth/sso-callback'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppDebugDataRouteImport } from './routes/_app/debug-data'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppTrafficIndexRouteImport } from './routes/_app/traffic/index'
import { Route as AppSpacesIndexRouteImport } from './routes/_app/spaces/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSeoIndexRouteImport } from './routes/_app/seo/index'
import { Route as AppPerformanceIndexRouteImport } from './routes/_app/performance/index'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppDocsIndexRouteImport } from './routes/_app/docs/index'
import { Route as AppConversionsIndexRouteImport } from './routes/_app/conversions/index'
import { Route as AppBehavioursIndexRouteImport } from './routes/_app/behaviours/index'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppTrafficSearchRouteImport } from './routes/_app/traffic/search'
import { Route as AppTrafficProfilesRouteImport } from './routes/_app/traffic/profiles'
import { Route as AppTrafficPageRouteImport } from './routes/_app/traffic/page'
import { Route as AppSpacesSpaceUuidRouteImport } from './routes/_app/spaces/$spaceUuid'
import { Route as AppSettingsWorkspaceRouteImport } from './routes/_app/settings/workspace'
import { Route as AppSettingsSitesRouteImport } from './routes/_app/settings/sites'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsPreferencesRouteImport } from './routes/_app/settings/preferences'
import { Route as AppSettingsPagesRouteImport } from './routes/_app/settings/pages'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsKeysRouteImport } from './routes/_app/settings/keys'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsDeploysRouteImport } from './routes/_app/settings/deploys'
import { Route as AppSettingsDangerRouteImport } from './routes/_app/settings/danger'
import { Route as AppSettingsBudgetsRouteImport } from './routes/_app/settings/budgets'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppSeoSitemapRouteImport } from './routes/_app/seo/sitemap'
import { Route as AppPerformanceThirdPartiesRouteImport } from './routes/_app/performance/third-parties'
import { Route as AppPerformanceRealRouteImport } from './routes/_app/performance/real'
import { Route as AppPerformanceProfilesRouteImport } from './routes/_app/performance/profiles'
import { Route as AppPerformanceFieldRouteImport } from './routes/_app/performance/field'
import { Route as AppMetricsExploreRouteImport } from './routes/_app/metrics/explore'
import { Route as AppDocsWebhooksRouteImport } from './routes/_app/docs/webhooks'
import { Route as AppDocsQuickstartRouteImport } from './routes/_app/docs/quickstart'
import { Route as AppDocsPixelRouteImport } from './routes/_app/docs/pixel'
import { Route as AppDocsChangelogRouteImport } from './routes/_app/docs/changelog'
import { Route as AppDocsApiRouteImport } from './routes/_app/docs/api'
import { Route as AppDocsAgentRouteImport } from './routes/_app/docs/agent'
import { Route as AppCliAuthorizeRouteImport } from './routes/_app/cli/authorize'
import { Route as AppAdminFinancesRouteImport } from './routes/_app/admin/finances'
import { Route as AppAdminAnalysisRouteImport } from './routes/_app/admin/analysis'
import { Route as AppAdminOrgUuidRouteImport } from './routes/_app/admin/$orgUuid'
import { Route as AppTrafficLiveIndexRouteImport } from './routes/_app/traffic/live/index'
import { Route as AppSettingsWebhooksIndexRouteImport } from './routes/_app/settings/webhooks/index'
import { Route as AppSettingsTeamsIndexRouteImport } from './routes/_app/settings/teams/index'
import { Route as AppSettingsLogsIndexRouteImport } from './routes/_app/settings/logs/index'
import { Route as AppPerformanceVariantsIndexRouteImport } from './routes/_app/performance/variants/index'
import { Route as AppPerformanceSegmentsIndexRouteImport } from './routes/_app/performance/segments/index'
import { Route as AppPerformanceAuditsIndexRouteImport } from './routes/_app/performance/audits/index'
import { Route as AppTrafficSessionSessionIdRouteImport } from './routes/_app/traffic/session.$sessionId'
import { Route as AppSettingsWebhooksNewRouteImport } from './routes/_app/settings/webhooks/new'
import { Route as AppSettingsTeamsTeamUuidRouteImport } from './routes/_app/settings/teams/$teamUuid'
import { Route as AppSettingsLogsAuditIdRouteImport } from './routes/_app/settings/logs/$auditId'
import { Route as AppPerformanceVariantsNewRouteImport } from './routes/_app/performance/variants/new'
import { Route as AppPerformanceVariantsVariantUuidRouteImport } from './routes/_app/performance/variants/$variantUuid'
import { Route as AppPerformanceSegmentsSegmentUuidRouteImport } from './routes/_app/performance/segments/$segmentUuid'
import { Route as AppPerformanceAuditsAuditIdRouteImport } from './routes/_app/performance/audits/$auditId'
import { Route as AppIntegrationsGoogleCallbackRouteImport } from './routes/_app/integrations/google/callback'
import { Route as AppSettingsWebhooksUuidEditRouteImport } from './routes/_app/settings/webhooks/$uuid/edit'
import { Route as AppSettingsWebhooksUuidDeliveriesRouteImport } from './routes/_app/settings/webhooks/$uuid/deliveries'

const UiSandboxRoute = UiSandboxRouteImport.update({
  id: '/ui-sandbox',
  path: '/ui-sandbox',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedRoute = EmbedRouteImport.update({
  id: '/embed',
  path: '/embed',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentRoute = AgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AuthWaitlistRoute = AuthWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifySignInRoute = AuthVerifySignInRouteImport.update({
  id: '/verify-sign-in',
  path: '/verify-sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTwoFactorRoute = AuthTwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppDebugDataRoute = AppDebugDataRouteImport.update({
  id: '/debug-data',
  path: '/debug-data',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppTrafficIndexRoute = AppTrafficIndexRouteImport.update({
  id: '/traffic/',
  path: '/traffic/',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesIndexRoute = AppSpacesIndexRouteImport.update({
  id: '/spaces/',
  path: '/spaces/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSeoIndexRoute = AppSeoIndexRouteImport.update({
  id: '/seo/',
  path: '/seo/',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceIndexRoute = AppPerformanceIndexRouteImport.update({
  id: '/performance/',
  path: '/performance/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsIndexRoute = AppDocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => AppRoute,
} as any)
const AppConversionsIndexRoute = AppConversionsIndexRouteImport.update({
  id: '/conversions/',
  path: '/conversions/',
  getParentRoute: () => AppRoute,
} as any)
const AppBehavioursIndexRoute = AppBehavioursIndexRouteImport.update({
  id: '/behaviours/',
  path: '/behaviours/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppTrafficSearchRoute = AppTrafficSearchRouteImport.update({
  id: '/traffic/search',
  path: '/traffic/search',
  getParentRoute: () => AppRoute,
} as any)
const AppTrafficProfilesRoute = AppTrafficProfilesRouteImport.update({
  id: '/traffic/profiles',
  path: '/traffic/profiles',
  getParentRoute: () => AppRoute,
} as any)
const AppTrafficPageRoute = AppTrafficPageRouteImport.update({
  id: '/traffic/page',
  path: '/traffic/page',
  getParentRoute: () => AppRoute,
} as any)
const AppSpacesSpaceUuidRoute = AppSpacesSpaceUuidRouteImport.update({
  id: '/spaces/$spaceUuid',
  path: '/spaces/$spaceUuid',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWorkspaceRoute = AppSettingsWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSitesRoute = AppSettingsSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPreferencesRoute = AppSettingsPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPagesRoute = AppSettingsPagesRouteImport.update({
  id: '/pages',
  path: '/pages',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsKeysRoute = AppSettingsKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDeploysRoute = AppSettingsDeploysRouteImport.update({
  id: '/deploys',
  path: '/deploys',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsDangerRoute = AppSettingsDangerRouteImport.update({
  id: '/danger',
  path: '/danger',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBudgetsRoute = AppSettingsBudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSeoSitemapRoute = AppSeoSitemapRouteImport.update({
  id: '/seo/sitemap',
  path: '/seo/sitemap',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceThirdPartiesRoute =
  AppPerformanceThirdPartiesRouteImport.update({
    id: '/performance/third-parties',
    path: '/performance/third-parties',
    getParentRoute: () => AppRoute,
  } as any)
const AppPerformanceRealRoute = AppPerformanceRealRouteImport.update({
  id: '/performance/real',
  path: '/performance/real',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceProfilesRoute = AppPerformanceProfilesRouteImport.update({
  id: '/performance/profiles',
  path: '/performance/profiles',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceFieldRoute = AppPerformanceFieldRouteImport.update({
  id: '/performance/field',
  path: '/performance/field',
  getParentRoute: () => AppRoute,
} as any)
const AppMetricsExploreRoute = AppMetricsExploreRouteImport.update({
  id: '/metrics/explore',
  path: '/metrics/explore',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsWebhooksRoute = AppDocsWebhooksRouteImport.update({
  id: '/docs/webhooks',
  path: '/docs/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsQuickstartRoute = AppDocsQuickstartRouteImport.update({
  id: '/docs/quickstart',
  path: '/docs/quickstart',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsPixelRoute = AppDocsPixelRouteImport.update({
  id: '/docs/pixel',
  path: '/docs/pixel',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsChangelogRoute = AppDocsChangelogRouteImport.update({
  id: '/docs/changelog',
  path: '/docs/changelog',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsApiRoute = AppDocsApiRouteImport.update({
  id: '/docs/api',
  path: '/docs/api',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsAgentRoute = AppDocsAgentRouteImport.update({
  id: '/docs/agent',
  path: '/docs/agent',
  getParentRoute: () => AppRoute,
} as any)
const AppCliAuthorizeRoute = AppCliAuthorizeRouteImport.update({
  id: '/cli/authorize',
  path: '/cli/authorize',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminFinancesRoute = AppAdminFinancesRouteImport.update({
  id: '/finances',
  path: '/finances',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAnalysisRoute = AppAdminAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOrgUuidRoute = AppAdminOrgUuidRouteImport.update({
  id: '/$orgUuid',
  path: '/$orgUuid',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppTrafficLiveIndexRoute = AppTrafficLiveIndexRouteImport.update({
  id: '/traffic/live/',
  path: '/traffic/live/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsWebhooksIndexRoute =
  AppSettingsWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsTeamsIndexRoute = AppSettingsTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsLogsIndexRoute = AppSettingsLogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppPerformanceVariantsIndexRoute =
  AppPerformanceVariantsIndexRouteImport.update({
    id: '/performance/variants/',
    path: '/performance/variants/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPerformanceSegmentsIndexRoute =
  AppPerformanceSegmentsIndexRouteImport.update({
    id: '/performance/segments/',
    path: '/performance/segments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPerformanceAuditsIndexRoute =
  AppPerformanceAuditsIndexRouteImport.update({
    id: '/performance/audits/',
    path: '/performance/audits/',
    getParentRoute: () => AppRoute,
  } as any)
const AppTrafficSessionSessionIdRoute =
  AppTrafficSessionSessionIdRouteImport.update({
    id: '/traffic/session/$sessionId',
    path: '/traffic/session/$sessionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsWebhooksNewRoute = AppSettingsWebhooksNewRouteImport.update({
  id: '/webhooks/new',
  path: '/webhooks/new',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTeamsTeamUuidRoute =
  AppSettingsTeamsTeamUuidRouteImport.update({
    id: '/teams/$teamUuid',
    path: '/teams/$teamUuid',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsLogsAuditIdRoute = AppSettingsLogsAuditIdRouteImport.update({
  id: '/logs/$auditId',
  path: '/logs/$auditId',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppPerformanceVariantsNewRoute =
  AppPerformanceVariantsNewRouteImport.update({
    id: '/performance/variants/new',
    path: '/performance/variants/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppPerformanceVariantsVariantUuidRoute =
  AppPerformanceVariantsVariantUuidRouteImport.update({
    id: '/performance/variants/$variantUuid',
    path: '/performance/variants/$variantUuid',
    getParentRoute: () => AppRoute,
  } as any)
const AppPerformanceSegmentsSegmentUuidRoute =
  AppPerformanceSegmentsSegmentUuidRouteImport.update({
    id: '/performance/segments/$segmentUuid',
    path: '/performance/segments/$segmentUuid',
    getParentRoute: () => AppRoute,
  } as any)
const AppPerformanceAuditsAuditIdRoute =
  AppPerformanceAuditsAuditIdRouteImport.update({
    id: '/performance/audits/$auditId',
    path: '/performance/audits/$auditId',
    getParentRoute: () => AppRoute,
  } as any)
const AppIntegrationsGoogleCallbackRoute =
  AppIntegrationsGoogleCallbackRouteImport.update({
    id: '/integrations/google/callback',
    path: '/integrations/google/callback',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsWebhooksUuidEditRoute =
  AppSettingsWebhooksUuidEditRouteImport.update({
    id: '/webhooks/$uuid/edit',
    path: '/webhooks/$uuid/edit',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsWebhooksUuidDeliveriesRoute =
  AppSettingsWebhooksUuidDeliveriesRouteImport.update({
    id: '/webhooks/$uuid/deliveries',
    path: '/webhooks/$uuid/deliveries',
    getParentRoute: () => AppSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/agent': typeof AgentRoute
  '/embed': typeof EmbedRoute
  '/onboarding': typeof OnboardingRoute
  '/ui-sandbox': typeof UiSandboxRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/debug-data': typeof AppDebugDataRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/sso-callback': typeof AuthSsoCallbackRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/verify-sign-in': typeof AuthVerifySignInRoute
  '/waitlist': typeof AuthWaitlistRoute
  '/admin/$orgUuid': typeof AppAdminOrgUuidRoute
  '/admin/analysis': typeof AppAdminAnalysisRoute
  '/admin/finances': typeof AppAdminFinancesRoute
  '/cli/authorize': typeof AppCliAuthorizeRoute
  '/docs/agent': typeof AppDocsAgentRoute
  '/docs/api': typeof AppDocsApiRoute
  '/docs/changelog': typeof AppDocsChangelogRoute
  '/docs/pixel': typeof AppDocsPixelRoute
  '/docs/quickstart': typeof AppDocsQuickstartRoute
  '/docs/webhooks': typeof AppDocsWebhooksRoute
  '/metrics/explore': typeof AppMetricsExploreRoute
  '/performance/field': typeof AppPerformanceFieldRoute
  '/performance/profiles': typeof AppPerformanceProfilesRoute
  '/performance/real': typeof AppPerformanceRealRoute
  '/performance/third-parties': typeof AppPerformanceThirdPartiesRoute
  '/seo/sitemap': typeof AppSeoSitemapRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/budgets': typeof AppSettingsBudgetsRoute
  '/settings/danger': typeof AppSettingsDangerRoute
  '/settings/deploys': typeof AppSettingsDeploysRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/keys': typeof AppSettingsKeysRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/pages': typeof AppSettingsPagesRoute
  '/settings/preferences': typeof AppSettingsPreferencesRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/sites': typeof AppSettingsSitesRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/spaces/$spaceUuid': typeof AppSpacesSpaceUuidRoute
  '/traffic/page': typeof AppTrafficPageRoute
  '/traffic/profiles': typeof AppTrafficProfilesRoute
  '/traffic/search': typeof AppTrafficSearchRoute
  '/admin/': typeof AppAdminIndexRoute
  '/behaviours/': typeof AppBehavioursIndexRoute
  '/conversions/': typeof AppConversionsIndexRoute
  '/docs/': typeof AppDocsIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/performance/': typeof AppPerformanceIndexRoute
  '/seo/': typeof AppSeoIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/spaces/': typeof AppSpacesIndexRoute
  '/traffic/': typeof AppTrafficIndexRoute
  '/integrations/google/callback': typeof AppIntegrationsGoogleCallbackRoute
  '/performance/audits/$auditId': typeof AppPerformanceAuditsAuditIdRoute
  '/performance/segments/$segmentUuid': typeof AppPerformanceSegmentsSegmentUuidRoute
  '/performance/variants/$variantUuid': typeof AppPerformanceVariantsVariantUuidRoute
  '/performance/variants/new': typeof AppPerformanceVariantsNewRoute
  '/settings/logs/$auditId': typeof AppSettingsLogsAuditIdRoute
  '/settings/teams/$teamUuid': typeof AppSettingsTeamsTeamUuidRoute
  '/settings/webhooks/new': typeof AppSettingsWebhooksNewRoute
  '/traffic/session/$sessionId': typeof AppTrafficSessionSessionIdRoute
  '/performance/audits/': typeof AppPerformanceAuditsIndexRoute
  '/performance/segments/': typeof AppPerformanceSegmentsIndexRoute
  '/performance/variants/': typeof AppPerformanceVariantsIndexRoute
  '/settings/logs/': typeof AppSettingsLogsIndexRoute
  '/settings/teams/': typeof AppSettingsTeamsIndexRoute
  '/settings/webhooks/': typeof AppSettingsWebhooksIndexRoute
  '/traffic/live/': typeof AppTrafficLiveIndexRoute
  '/settings/webhooks/$uuid/deliveries': typeof AppSettingsWebhooksUuidDeliveriesRoute
  '/settings/webhooks/$uuid/edit': typeof AppSettingsWebhooksUuidEditRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/agent': typeof AgentRoute
  '/embed': typeof EmbedRoute
  '/onboarding': typeof OnboardingRoute
  '/ui-sandbox': typeof UiSandboxRoute
  '/debug-data': typeof AppDebugDataRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/sso-callback': typeof AuthSsoCallbackRoute
  '/two-factor': typeof AuthTwoFactorRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/verify-sign-in': typeof AuthVerifySignInRoute
  '/waitlist': typeof AuthWaitlistRoute
  '/admin/$orgUuid': typeof AppAdminOrgUuidRoute
  '/admin/analysis': typeof AppAdminAnalysisRoute
  '/admin/finances': typeof AppAdminFinancesRoute
  '/cli/authorize': typeof AppCliAuthorizeRoute
  '/docs/agent': typeof AppDocsAgentRoute
  '/docs/api': typeof AppDocsApiRoute
  '/docs/changelog': typeof AppDocsChangelogRoute
  '/docs/pixel': typeof AppDocsPixelRoute
  '/docs/quickstart': typeof AppDocsQuickstartRoute
  '/docs/webhooks': typeof AppDocsWebhooksRoute
  '/metrics/explore': typeof AppMetricsExploreRoute
  '/performance/field': typeof AppPerformanceFieldRoute
  '/performance/profiles': typeof AppPerformanceProfilesRoute
  '/performance/real': typeof AppPerformanceRealRoute
  '/performance/third-parties': typeof AppPerformanceThirdPartiesRoute
  '/seo/sitemap': typeof AppSeoSitemapRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/budgets': typeof AppSettingsBudgetsRoute
  '/settings/danger': typeof AppSettingsDangerRoute
  '/settings/deploys': typeof AppSettingsDeploysRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/keys': typeof AppSettingsKeysRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/pages': typeof AppSettingsPagesRoute
  '/settings/preferences': typeof AppSettingsPreferencesRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/sites': typeof AppSettingsSitesRoute
  '/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/spaces/$spaceUuid': typeof AppSpacesSpaceUuidRoute
  '/traffic/page': typeof AppTrafficPageRoute
  '/traffic/profiles': typeof AppTrafficProfilesRoute
  '/traffic/search': typeof AppTrafficSearchRoute
  '/admin': typeof AppAdminIndexRoute
  '/behaviours': typeof AppBehavioursIndexRoute
  '/conversions': typeof AppConversionsIndexRoute
  '/docs': typeof AppDocsIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/performance': typeof AppPerformanceIndexRoute
  '/seo': typeof AppSeoIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/spaces': typeof AppSpacesIndexRoute
  '/traffic': typeof AppTrafficIndexRoute
  '/integrations/google/callback': typeof AppIntegrationsGoogleCallbackRoute
  '/performance/audits/$auditId': typeof AppPerformanceAuditsAuditIdRoute
  '/performance/segments/$segmentUuid': typeof AppPerformanceSegmentsSegmentUuidRoute
  '/performance/variants/$variantUuid': typeof AppPerformanceVariantsVariantUuidRoute
  '/performance/variants/new': typeof AppPerformanceVariantsNewRoute
  '/settings/logs/$auditId': typeof AppSettingsLogsAuditIdRoute
  '/settings/teams/$teamUuid': typeof AppSettingsTeamsTeamUuidRoute
  '/settings/webhooks/new': typeof AppSettingsWebhooksNewRoute
  '/traffic/session/$sessionId': typeof AppTrafficSessionSessionIdRoute
  '/performance/audits': typeof AppPerformanceAuditsIndexRoute
  '/performance/segments': typeof AppPerformanceSegmentsIndexRoute
  '/performance/variants': typeof AppPerformanceVariantsIndexRoute
  '/settings/logs': typeof AppSettingsLogsIndexRoute
  '/settings/teams': typeof AppSettingsTeamsIndexRoute
  '/settings/webhooks': typeof AppSettingsWebhooksIndexRoute
  '/traffic/live': typeof AppTrafficLiveIndexRoute
  '/settings/webhooks/$uuid/deliveries': typeof AppSettingsWebhooksUuidDeliveriesRoute
  '/settings/webhooks/$uuid/edit': typeof AppSettingsWebhooksUuidEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/agent': typeof AgentRoute
  '/embed': typeof EmbedRoute
  '/onboarding': typeof OnboardingRoute
  '/ui-sandbox': typeof UiSandboxRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/debug-data': typeof AppDebugDataRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/sso-callback': typeof AuthSsoCallbackRoute
  '/_auth/two-factor': typeof AuthTwoFactorRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_auth/verify-sign-in': typeof AuthVerifySignInRoute
  '/_auth/waitlist': typeof AuthWaitlistRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/$orgUuid': typeof AppAdminOrgUuidRoute
  '/_app/admin/analysis': typeof AppAdminAnalysisRoute
  '/_app/admin/finances': typeof AppAdminFinancesRoute
  '/_app/cli/authorize': typeof AppCliAuthorizeRoute
  '/_app/docs/agent': typeof AppDocsAgentRoute
  '/_app/docs/api': typeof AppDocsApiRoute
  '/_app/docs/changelog': typeof AppDocsChangelogRoute
  '/_app/docs/pixel': typeof AppDocsPixelRoute
  '/_app/docs/quickstart': typeof AppDocsQuickstartRoute
  '/_app/docs/webhooks': typeof AppDocsWebhooksRoute
  '/_app/metrics/explore': typeof AppMetricsExploreRoute
  '/_app/performance/field': typeof AppPerformanceFieldRoute
  '/_app/performance/profiles': typeof AppPerformanceProfilesRoute
  '/_app/performance/real': typeof AppPerformanceRealRoute
  '/_app/performance/third-parties': typeof AppPerformanceThirdPartiesRoute
  '/_app/seo/sitemap': typeof AppSeoSitemapRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/budgets': typeof AppSettingsBudgetsRoute
  '/_app/settings/danger': typeof AppSettingsDangerRoute
  '/_app/settings/deploys': typeof AppSettingsDeploysRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/keys': typeof AppSettingsKeysRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/pages': typeof AppSettingsPagesRoute
  '/_app/settings/preferences': typeof AppSettingsPreferencesRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/sites': typeof AppSettingsSitesRoute
  '/_app/settings/workspace': typeof AppSettingsWorkspaceRoute
  '/_app/spaces/$spaceUuid': typeof AppSpacesSpaceUuidRoute
  '/_app/traffic/page': typeof AppTrafficPageRoute
  '/_app/traffic/profiles': typeof AppTrafficProfilesRoute
  '/_app/traffic/search': typeof AppTrafficSearchRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/behaviours/': typeof AppBehavioursIndexRoute
  '/_app/conversions/': typeof AppConversionsIndexRoute
  '/_app/docs/': typeof AppDocsIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/performance/': typeof AppPerformanceIndexRoute
  '/_app/seo/': typeof AppSeoIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/spaces/': typeof AppSpacesIndexRoute
  '/_app/traffic/': typeof AppTrafficIndexRoute
  '/_app/integrations/google/callback': typeof AppIntegrationsGoogleCallbackRoute
  '/_app/performance/audits/$auditId': typeof AppPerformanceAuditsAuditIdRoute
  '/_app/performance/segments/$segmentUuid': typeof AppPerformanceSegmentsSegmentUuidRoute
  '/_app/performance/variants/$variantUuid': typeof AppPerformanceVariantsVariantUuidRoute
  '/_app/performance/variants/new': typeof AppPerformanceVariantsNewRoute
  '/_app/settings/logs/$auditId': typeof AppSettingsLogsAuditIdRoute
  '/_app/settings/teams/$teamUuid': typeof AppSettingsTeamsTeamUuidRoute
  '/_app/settings/webhooks/new': typeof AppSettingsWebhooksNewRoute
  '/_app/traffic/session/$sessionId': typeof AppTrafficSessionSessionIdRoute
  '/_app/performance/audits/': typeof AppPerformanceAuditsIndexRoute
  '/_app/performance/segments/': typeof AppPerformanceSegmentsIndexRoute
  '/_app/performance/variants/': typeof AppPerformanceVariantsIndexRoute
  '/_app/settings/logs/': typeof AppSettingsLogsIndexRoute
  '/_app/settings/teams/': typeof AppSettingsTeamsIndexRoute
  '/_app/settings/webhooks/': typeof AppSettingsWebhooksIndexRoute
  '/_app/traffic/live/': typeof AppTrafficLiveIndexRoute
  '/_app/settings/webhooks/$uuid/deliveries': typeof AppSettingsWebhooksUuidDeliveriesRoute
  '/_app/settings/webhooks/$uuid/edit': typeof AppSettingsWebhooksUuidEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agent'
    | '/embed'
    | '/onboarding'
    | '/ui-sandbox'
    | '/admin'
    | '/debug-data'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/two-factor'
    | '/verify-email'
    | '/verify-sign-in'
    | '/waitlist'
    | '/admin/$orgUuid'
    | '/admin/analysis'
    | '/admin/finances'
    | '/cli/authorize'
    | '/docs/agent'
    | '/docs/api'
    | '/docs/changelog'
    | '/docs/pixel'
    | '/docs/quickstart'
    | '/docs/webhooks'
    | '/metrics/explore'
    | '/performance/field'
    | '/performance/profiles'
    | '/performance/real'
    | '/performance/third-parties'
    | '/seo/sitemap'
    | '/settings/billing'
    | '/settings/budgets'
    | '/settings/danger'
    | '/settings/deploys'
    | '/settings/integrations'
    | '/settings/keys'
    | '/settings/members'
    | '/settings/pages'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/sites'
    | '/settings/workspace'
    | '/spaces/$spaceUuid'
    | '/traffic/page'
    | '/traffic/profiles'
    | '/traffic/search'
    | '/admin/'
    | '/behaviours/'
    | '/conversions/'
    | '/docs/'
    | '/help/'
    | '/performance/'
    | '/seo/'
    | '/settings/'
    | '/spaces/'
    | '/traffic/'
    | '/integrations/google/callback'
    | '/performance/audits/$auditId'
    | '/performance/segments/$segmentUuid'
    | '/performance/variants/$variantUuid'
    | '/performance/variants/new'
    | '/settings/logs/$auditId'
    | '/settings/teams/$teamUuid'
    | '/settings/webhooks/new'
    | '/traffic/session/$sessionId'
    | '/performance/audits/'
    | '/performance/segments/'
    | '/performance/variants/'
    | '/settings/logs/'
    | '/settings/teams/'
    | '/settings/webhooks/'
    | '/traffic/live/'
    | '/settings/webhooks/$uuid/deliveries'
    | '/settings/webhooks/$uuid/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent'
    | '/embed'
    | '/onboarding'
    | '/ui-sandbox'
    | '/debug-data'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/sso-callback'
    | '/two-factor'
    | '/verify-email'
    | '/verify-sign-in'
    | '/waitlist'
    | '/admin/$orgUuid'
    | '/admin/analysis'
    | '/admin/finances'
    | '/cli/authorize'
    | '/docs/agent'
    | '/docs/api'
    | '/docs/changelog'
    | '/docs/pixel'
    | '/docs/quickstart'
    | '/docs/webhooks'
    | '/metrics/explore'
    | '/performance/field'
    | '/performance/profiles'
    | '/performance/real'
    | '/performance/third-parties'
    | '/seo/sitemap'
    | '/settings/billing'
    | '/settings/budgets'
    | '/settings/danger'
    | '/settings/deploys'
    | '/settings/integrations'
    | '/settings/keys'
    | '/settings/members'
    | '/settings/pages'
    | '/settings/preferences'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/sites'
    | '/settings/workspace'
    | '/spaces/$spaceUuid'
    | '/traffic/page'
    | '/traffic/profiles'
    | '/traffic/search'
    | '/admin'
    | '/behaviours'
    | '/conversions'
    | '/docs'
    | '/help'
    | '/performance'
    | '/seo'
    | '/settings'
    | '/spaces'
    | '/traffic'
    | '/integrations/google/callback'
    | '/performance/audits/$auditId'
    | '/performance/segments/$segmentUuid'
    | '/performance/variants/$variantUuid'
    | '/performance/variants/new'
    | '/settings/logs/$auditId'
    | '/settings/teams/$teamUuid'
    | '/settings/webhooks/new'
    | '/traffic/session/$sessionId'
    | '/performance/audits'
    | '/performance/segments'
    | '/performance/variants'
    | '/settings/logs'
    | '/settings/teams'
    | '/settings/webhooks'
    | '/traffic/live'
    | '/settings/webhooks/$uuid/deliveries'
    | '/settings/webhooks/$uuid/edit'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/agent'
    | '/embed'
    | '/onboarding'
    | '/ui-sandbox'
    | '/_app/admin'
    | '/_app/debug-data'
    | '/_app/settings'
    | '/_auth/forgot-password'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/sso-callback'
    | '/_auth/two-factor'
    | '/_auth/verify-email'
    | '/_auth/verify-sign-in'
    | '/_auth/waitlist'
    | '/_app/'
    | '/_app/admin/$orgUuid'
    | '/_app/admin/analysis'
    | '/_app/admin/finances'
    | '/_app/cli/authorize'
    | '/_app/docs/agent'
    | '/_app/docs/api'
    | '/_app/docs/changelog'
    | '/_app/docs/pixel'
    | '/_app/docs/quickstart'
    | '/_app/docs/webhooks'
    | '/_app/metrics/explore'
    | '/_app/performance/field'
    | '/_app/performance/profiles'
    | '/_app/performance/real'
    | '/_app/performance/third-parties'
    | '/_app/seo/sitemap'
    | '/_app/settings/billing'
    | '/_app/settings/budgets'
    | '/_app/settings/danger'
    | '/_app/settings/deploys'
    | '/_app/settings/integrations'
    | '/_app/settings/keys'
    | '/_app/settings/members'
    | '/_app/settings/pages'
    | '/_app/settings/preferences'
    | '/_app/settings/profile'
    | '/_app/settings/security'
    | '/_app/settings/sites'
    | '/_app/settings/workspace'
    | '/_app/spaces/$spaceUuid'
    | '/_app/traffic/page'
    | '/_app/traffic/profiles'
    | '/_app/traffic/search'
    | '/_app/admin/'
    | '/_app/behaviours/'
    | '/_app/conversions/'
    | '/_app/docs/'
    | '/_app/help/'
    | '/_app/performance/'
    | '/_app/seo/'
    | '/_app/settings/'
    | '/_app/spaces/'
    | '/_app/traffic/'
    | '/_app/integrations/google/callback'
    | '/_app/performance/audits/$auditId'
    | '/_app/performance/segments/$segmentUuid'
    | '/_app/performance/variants/$variantUuid'
    | '/_app/performance/variants/new'
    | '/_app/settings/logs/$auditId'
    | '/_app/settings/teams/$teamUuid'
    | '/_app/settings/webhooks/new'
    | '/_app/traffic/session/$sessionId'
    | '/_app/performance/audits/'
    | '/_app/performance/segments/'
    | '/_app/performance/variants/'
    | '/_app/settings/logs/'
    | '/_app/settings/teams/'
    | '/_app/settings/webhooks/'
    | '/_app/traffic/live/'
    | '/_app/settings/webhooks/$uuid/deliveries'
    | '/_app/settings/webhooks/$uuid/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AgentRoute: typeof AgentRoute
  EmbedRoute: typeof EmbedRoute
  OnboardingRoute: typeof OnboardingRoute
  UiSandboxRoute: typeof UiSandboxRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/ui-sandbox': {
      id: '/ui-sandbox'
      path: '/ui-sandbox'
      fullPath: '/ui-sandbox'
      preLoaderRoute: typeof UiSandboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed': {
      id: '/embed'
      path: '/embed'
      fullPath: '/embed'
      preLoaderRoute: typeof EmbedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agent': {
      id: '/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AgentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/waitlist': {
      id: '/_auth/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof AuthWaitlistRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-sign-in': {
      id: '/_auth/verify-sign-in'
      path: '/verify-sign-in'
      fullPath: '/verify-sign-in'
      preLoaderRoute: typeof AuthVerifySignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/two-factor': {
      id: '/_auth/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof AuthTwoFactorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sso-callback': {
      id: '/_auth/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/debug-data': {
      id: '/_app/debug-data'
      path: '/debug-data'
      fullPath: '/debug-data'
      preLoaderRoute: typeof AppDebugDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traffic/': {
      id: '/_app/traffic/'
      path: '/traffic'
      fullPath: '/traffic/'
      preLoaderRoute: typeof AppTrafficIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/': {
      id: '/_app/spaces/'
      path: '/spaces'
      fullPath: '/spaces/'
      preLoaderRoute: typeof AppSpacesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/seo/': {
      id: '/_app/seo/'
      path: '/seo'
      fullPath: '/seo/'
      preLoaderRoute: typeof AppSeoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/': {
      id: '/_app/performance/'
      path: '/performance'
      fullPath: '/performance/'
      preLoaderRoute: typeof AppPerformanceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/': {
      id: '/_app/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof AppDocsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conversions/': {
      id: '/_app/conversions/'
      path: '/conversions'
      fullPath: '/conversions/'
      preLoaderRoute: typeof AppConversionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/behaviours/': {
      id: '/_app/behaviours/'
      path: '/behaviours'
      fullPath: '/behaviours/'
      preLoaderRoute: typeof AppBehavioursIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/traffic/search': {
      id: '/_app/traffic/search'
      path: '/traffic/search'
      fullPath: '/traffic/search'
      preLoaderRoute: typeof AppTrafficSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traffic/profiles': {
      id: '/_app/traffic/profiles'
      path: '/traffic/profiles'
      fullPath: '/traffic/profiles'
      preLoaderRoute: typeof AppTrafficProfilesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traffic/page': {
      id: '/_app/traffic/page'
      path: '/traffic/page'
      fullPath: '/traffic/page'
      preLoaderRoute: typeof AppTrafficPageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/spaces/$spaceUuid': {
      id: '/_app/spaces/$spaceUuid'
      path: '/spaces/$spaceUuid'
      fullPath: '/spaces/$spaceUuid'
      preLoaderRoute: typeof AppSpacesSpaceUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/workspace': {
      id: '/_app/settings/workspace'
      path: '/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AppSettingsWorkspaceRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sites': {
      id: '/_app/settings/sites'
      path: '/sites'
      fullPath: '/settings/sites'
      preLoaderRoute: typeof AppSettingsSitesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/preferences': {
      id: '/_app/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof AppSettingsPreferencesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/pages': {
      id: '/_app/settings/pages'
      path: '/pages'
      fullPath: '/settings/pages'
      preLoaderRoute: typeof AppSettingsPagesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/keys': {
      id: '/_app/settings/keys'
      path: '/keys'
      fullPath: '/settings/keys'
      preLoaderRoute: typeof AppSettingsKeysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/deploys': {
      id: '/_app/settings/deploys'
      path: '/deploys'
      fullPath: '/settings/deploys'
      preLoaderRoute: typeof AppSettingsDeploysRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/danger': {
      id: '/_app/settings/danger'
      path: '/danger'
      fullPath: '/settings/danger'
      preLoaderRoute: typeof AppSettingsDangerRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/budgets': {
      id: '/_app/settings/budgets'
      path: '/budgets'
      fullPath: '/settings/budgets'
      preLoaderRoute: typeof AppSettingsBudgetsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/seo/sitemap': {
      id: '/_app/seo/sitemap'
      path: '/seo/sitemap'
      fullPath: '/seo/sitemap'
      preLoaderRoute: typeof AppSeoSitemapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/third-parties': {
      id: '/_app/performance/third-parties'
      path: '/performance/third-parties'
      fullPath: '/performance/third-parties'
      preLoaderRoute: typeof AppPerformanceThirdPartiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/real': {
      id: '/_app/performance/real'
      path: '/performance/real'
      fullPath: '/performance/real'
      preLoaderRoute: typeof AppPerformanceRealRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/profiles': {
      id: '/_app/performance/profiles'
      path: '/performance/profiles'
      fullPath: '/performance/profiles'
      preLoaderRoute: typeof AppPerformanceProfilesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/field': {
      id: '/_app/performance/field'
      path: '/performance/field'
      fullPath: '/performance/field'
      preLoaderRoute: typeof AppPerformanceFieldRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/metrics/explore': {
      id: '/_app/metrics/explore'
      path: '/metrics/explore'
      fullPath: '/metrics/explore'
      preLoaderRoute: typeof AppMetricsExploreRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/webhooks': {
      id: '/_app/docs/webhooks'
      path: '/docs/webhooks'
      fullPath: '/docs/webhooks'
      preLoaderRoute: typeof AppDocsWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/quickstart': {
      id: '/_app/docs/quickstart'
      path: '/docs/quickstart'
      fullPath: '/docs/quickstart'
      preLoaderRoute: typeof AppDocsQuickstartRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/pixel': {
      id: '/_app/docs/pixel'
      path: '/docs/pixel'
      fullPath: '/docs/pixel'
      preLoaderRoute: typeof AppDocsPixelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/changelog': {
      id: '/_app/docs/changelog'
      path: '/docs/changelog'
      fullPath: '/docs/changelog'
      preLoaderRoute: typeof AppDocsChangelogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/api': {
      id: '/_app/docs/api'
      path: '/docs/api'
      fullPath: '/docs/api'
      preLoaderRoute: typeof AppDocsApiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/agent': {
      id: '/_app/docs/agent'
      path: '/docs/agent'
      fullPath: '/docs/agent'
      preLoaderRoute: typeof AppDocsAgentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cli/authorize': {
      id: '/_app/cli/authorize'
      path: '/cli/authorize'
      fullPath: '/cli/authorize'
      preLoaderRoute: typeof AppCliAuthorizeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/finances': {
      id: '/_app/admin/finances'
      path: '/finances'
      fullPath: '/admin/finances'
      preLoaderRoute: typeof AppAdminFinancesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/analysis': {
      id: '/_app/admin/analysis'
      path: '/analysis'
      fullPath: '/admin/analysis'
      preLoaderRoute: typeof AppAdminAnalysisRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/$orgUuid': {
      id: '/_app/admin/$orgUuid'
      path: '/$orgUuid'
      fullPath: '/admin/$orgUuid'
      preLoaderRoute: typeof AppAdminOrgUuidRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/traffic/live/': {
      id: '/_app/traffic/live/'
      path: '/traffic/live'
      fullPath: '/traffic/live/'
      preLoaderRoute: typeof AppTrafficLiveIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/webhooks/': {
      id: '/_app/settings/webhooks/'
      path: '/webhooks'
      fullPath: '/settings/webhooks/'
      preLoaderRoute: typeof AppSettingsWebhooksIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/teams/': {
      id: '/_app/settings/teams/'
      path: '/teams'
      fullPath: '/settings/teams/'
      preLoaderRoute: typeof AppSettingsTeamsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/logs/': {
      id: '/_app/settings/logs/'
      path: '/logs'
      fullPath: '/settings/logs/'
      preLoaderRoute: typeof AppSettingsLogsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/performance/variants/': {
      id: '/_app/performance/variants/'
      path: '/performance/variants'
      fullPath: '/performance/variants/'
      preLoaderRoute: typeof AppPerformanceVariantsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/segments/': {
      id: '/_app/performance/segments/'
      path: '/performance/segments'
      fullPath: '/performance/segments/'
      preLoaderRoute: typeof AppPerformanceSegmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/audits/': {
      id: '/_app/performance/audits/'
      path: '/performance/audits'
      fullPath: '/performance/audits/'
      preLoaderRoute: typeof AppPerformanceAuditsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/traffic/session/$sessionId': {
      id: '/_app/traffic/session/$sessionId'
      path: '/traffic/session/$sessionId'
      fullPath: '/traffic/session/$sessionId'
      preLoaderRoute: typeof AppTrafficSessionSessionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/webhooks/new': {
      id: '/_app/settings/webhooks/new'
      path: '/webhooks/new'
      fullPath: '/settings/webhooks/new'
      preLoaderRoute: typeof AppSettingsWebhooksNewRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/teams/$teamUuid': {
      id: '/_app/settings/teams/$teamUuid'
      path: '/teams/$teamUuid'
      fullPath: '/settings/teams/$teamUuid'
      preLoaderRoute: typeof AppSettingsTeamsTeamUuidRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/logs/$auditId': {
      id: '/_app/settings/logs/$auditId'
      path: '/logs/$auditId'
      fullPath: '/settings/logs/$auditId'
      preLoaderRoute: typeof AppSettingsLogsAuditIdRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/performance/variants/new': {
      id: '/_app/performance/variants/new'
      path: '/performance/variants/new'
      fullPath: '/performance/variants/new'
      preLoaderRoute: typeof AppPerformanceVariantsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/variants/$variantUuid': {
      id: '/_app/performance/variants/$variantUuid'
      path: '/performance/variants/$variantUuid'
      fullPath: '/performance/variants/$variantUuid'
      preLoaderRoute: typeof AppPerformanceVariantsVariantUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/segments/$segmentUuid': {
      id: '/_app/performance/segments/$segmentUuid'
      path: '/performance/segments/$segmentUuid'
      fullPath: '/performance/segments/$segmentUuid'
      preLoaderRoute: typeof AppPerformanceSegmentsSegmentUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance/audits/$auditId': {
      id: '/_app/performance/audits/$auditId'
      path: '/performance/audits/$auditId'
      fullPath: '/performance/audits/$auditId'
      preLoaderRoute: typeof AppPerformanceAuditsAuditIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integrations/google/callback': {
      id: '/_app/integrations/google/callback'
      path: '/integrations/google/callback'
      fullPath: '/integrations/google/callback'
      preLoaderRoute: typeof AppIntegrationsGoogleCallbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/webhooks/$uuid/edit': {
      id: '/_app/settings/webhooks/$uuid/edit'
      path: '/webhooks/$uuid/edit'
      fullPath: '/settings/webhooks/$uuid/edit'
      preLoaderRoute: typeof AppSettingsWebhooksUuidEditRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/webhooks/$uuid/deliveries': {
      id: '/_app/settings/webhooks/$uuid/deliveries'
      path: '/webhooks/$uuid/deliveries'
      fullPath: '/settings/webhooks/$uuid/deliveries'
      preLoaderRoute: typeof AppSettingsWebhooksUuidDeliveriesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminOrgUuidRoute: typeof AppAdminOrgUuidRoute
  AppAdminAnalysisRoute: typeof AppAdminAnalysisRoute
  AppAdminFinancesRoute: typeof AppAdminFinancesRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminOrgUuidRoute: AppAdminOrgUuidRoute,
  AppAdminAnalysisRoute: AppAdminAnalysisRoute,
  AppAdminFinancesRoute: AppAdminFinancesRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsBudgetsRoute: typeof AppSettingsBudgetsRoute
  AppSettingsDangerRoute: typeof AppSettingsDangerRoute
  AppSettingsDeploysRoute: typeof AppSettingsDeploysRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsKeysRoute: typeof AppSettingsKeysRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsPagesRoute: typeof AppSettingsPagesRoute
  AppSettingsPreferencesRoute: typeof AppSettingsPreferencesRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsSitesRoute: typeof AppSettingsSitesRoute
  AppSettingsWorkspaceRoute: typeof AppSettingsWorkspaceRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsLogsAuditIdRoute: typeof AppSettingsLogsAuditIdRoute
  AppSettingsTeamsTeamUuidRoute: typeof AppSettingsTeamsTeamUuidRoute
  AppSettingsWebhooksNewRoute: typeof AppSettingsWebhooksNewRoute
  AppSettingsLogsIndexRoute: typeof AppSettingsLogsIndexRoute
  AppSettingsTeamsIndexRoute: typeof AppSettingsTeamsIndexRoute
  AppSettingsWebhooksIndexRoute: typeof AppSettingsWebhooksIndexRoute
  AppSettingsWebhooksUuidDeliveriesRoute: typeof AppSettingsWebhooksUuidDeliveriesRoute
  AppSettingsWebhooksUuidEditRoute: typeof AppSettingsWebhooksUuidEditRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsBudgetsRoute: AppSettingsBudgetsRoute,
  AppSettingsDangerRoute: AppSettingsDangerRoute,
  AppSettingsDeploysRoute: AppSettingsDeploysRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsKeysRoute: AppSettingsKeysRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsPagesRoute: AppSettingsPagesRoute,
  AppSettingsPreferencesRoute: AppSettingsPreferencesRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsSitesRoute: AppSettingsSitesRoute,
  AppSettingsWorkspaceRoute: AppSettingsWorkspaceRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsLogsAuditIdRoute: AppSettingsLogsAuditIdRoute,
  AppSettingsTeamsTeamUuidRoute: AppSettingsTeamsTeamUuidRoute,
  AppSettingsWebhooksNewRoute: AppSettingsWebhooksNewRoute,
  AppSettingsLogsIndexRoute: AppSettingsLogsIndexRoute,
  AppSettingsTeamsIndexRoute: AppSettingsTeamsIndexRoute,
  AppSettingsWebhooksIndexRoute: AppSettingsWebhooksIndexRoute,
  AppSettingsWebhooksUuidDeliveriesRoute:
    AppSettingsWebhooksUuidDeliveriesRoute,
  AppSettingsWebhooksUuidEditRoute: AppSettingsWebhooksUuidEditRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDebugDataRoute: typeof AppDebugDataRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCliAuthorizeRoute: typeof AppCliAuthorizeRoute
  AppDocsAgentRoute: typeof AppDocsAgentRoute
  AppDocsApiRoute: typeof AppDocsApiRoute
  AppDocsChangelogRoute: typeof AppDocsChangelogRoute
  AppDocsPixelRoute: typeof AppDocsPixelRoute
  AppDocsQuickstartRoute: typeof AppDocsQuickstartRoute
  AppDocsWebhooksRoute: typeof AppDocsWebhooksRoute
  AppMetricsExploreRoute: typeof AppMetricsExploreRoute
  AppPerformanceFieldRoute: typeof AppPerformanceFieldRoute
  AppPerformanceProfilesRoute: typeof AppPerformanceProfilesRoute
  AppPerformanceRealRoute: typeof AppPerformanceRealRoute
  AppPerformanceThirdPartiesRoute: typeof AppPerformanceThirdPartiesRoute
  AppSeoSitemapRoute: typeof AppSeoSitemapRoute
  AppSpacesSpaceUuidRoute: typeof AppSpacesSpaceUuidRoute
  AppTrafficPageRoute: typeof AppTrafficPageRoute
  AppTrafficProfilesRoute: typeof AppTrafficProfilesRoute
  AppTrafficSearchRoute: typeof AppTrafficSearchRoute
  AppBehavioursIndexRoute: typeof AppBehavioursIndexRoute
  AppConversionsIndexRoute: typeof AppConversionsIndexRoute
  AppDocsIndexRoute: typeof AppDocsIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppPerformanceIndexRoute: typeof AppPerformanceIndexRoute
  AppSeoIndexRoute: typeof AppSeoIndexRoute
  AppSpacesIndexRoute: typeof AppSpacesIndexRoute
  AppTrafficIndexRoute: typeof AppTrafficIndexRoute
  AppIntegrationsGoogleCallbackRoute: typeof AppIntegrationsGoogleCallbackRoute
  AppPerformanceAuditsAuditIdRoute: typeof AppPerformanceAuditsAuditIdRoute
  AppPerformanceSegmentsSegmentUuidRoute: typeof AppPerformanceSegmentsSegmentUuidRoute
  AppPerformanceVariantsVariantUuidRoute: typeof AppPerformanceVariantsVariantUuidRoute
  AppPerformanceVariantsNewRoute: typeof AppPerformanceVariantsNewRoute
  AppTrafficSessionSessionIdRoute: typeof AppTrafficSessionSessionIdRoute
  AppPerformanceAuditsIndexRoute: typeof AppPerformanceAuditsIndexRoute
  AppPerformanceSegmentsIndexRoute: typeof AppPerformanceSegmentsIndexRoute
  AppPerformanceVariantsIndexRoute: typeof AppPerformanceVariantsIndexRoute
  AppTrafficLiveIndexRoute: typeof AppTrafficLiveIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDebugDataRoute: AppDebugDataRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCliAuthorizeRoute: AppCliAuthorizeRoute,
  AppDocsAgentRoute: AppDocsAgentRoute,
  AppDocsApiRoute: AppDocsApiRoute,
  AppDocsChangelogRoute: AppDocsChangelogRoute,
  AppDocsPixelRoute: AppDocsPixelRoute,
  AppDocsQuickstartRoute: AppDocsQuickstartRoute,
  AppDocsWebhooksRoute: AppDocsWebhooksRoute,
  AppMetricsExploreRoute: AppMetricsExploreRoute,
  AppPerformanceFieldRoute: AppPerformanceFieldRoute,
  AppPerformanceProfilesRoute: AppPerformanceProfilesRoute,
  AppPerformanceRealRoute: AppPerformanceRealRoute,
  AppPerformanceThirdPartiesRoute: AppPerformanceThirdPartiesRoute,
  AppSeoSitemapRoute: AppSeoSitemapRoute,
  AppSpacesSpaceUuidRoute: AppSpacesSpaceUuidRoute,
  AppTrafficPageRoute: AppTrafficPageRoute,
  AppTrafficProfilesRoute: AppTrafficProfilesRoute,
  AppTrafficSearchRoute: AppTrafficSearchRoute,
  AppBehavioursIndexRoute: AppBehavioursIndexRoute,
  AppConversionsIndexRoute: AppConversionsIndexRoute,
  AppDocsIndexRoute: AppDocsIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppPerformanceIndexRoute: AppPerformanceIndexRoute,
  AppSeoIndexRoute: AppSeoIndexRoute,
  AppSpacesIndexRoute: AppSpacesIndexRoute,
  AppTrafficIndexRoute: AppTrafficIndexRoute,
  AppIntegrationsGoogleCallbackRoute: AppIntegrationsGoogleCallbackRoute,
  AppPerformanceAuditsAuditIdRoute: AppPerformanceAuditsAuditIdRoute,
  AppPerformanceSegmentsSegmentUuidRoute:
    AppPerformanceSegmentsSegmentUuidRoute,
  AppPerformanceVariantsVariantUuidRoute:
    AppPerformanceVariantsVariantUuidRoute,
  AppPerformanceVariantsNewRoute: AppPerformanceVariantsNewRoute,
  AppTrafficSessionSessionIdRoute: AppTrafficSessionSessionIdRoute,
  AppPerformanceAuditsIndexRoute: AppPerformanceAuditsIndexRoute,
  AppPerformanceSegmentsIndexRoute: AppPerformanceSegmentsIndexRoute,
  AppPerformanceVariantsIndexRoute: AppPerformanceVariantsIndexRoute,
  AppTrafficLiveIndexRoute: AppTrafficLiveIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
  AuthTwoFactorRoute: typeof AuthTwoFactorRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthVerifySignInRoute: typeof AuthVerifySignInRoute
  AuthWaitlistRoute: typeof AuthWaitlistRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
  AuthTwoFactorRoute: AuthTwoFactorRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthVerifySignInRoute: AuthVerifySignInRoute,
  AuthWaitlistRoute: AuthWaitlistRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AgentRoute: AgentRoute,
  EmbedRoute: EmbedRoute,
  OnboardingRoute: OnboardingRoute,
  UiSandboxRoute: UiSandboxRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
